"use client";

import { useSearchParams } from "next/navigation";
import { Suspense } from "react";
import { Select } from "./select";

function Filter({ paramName }: { paramName: string }) {
  const searchParams = useSearchParams();
  const val = searchParams.get(paramName) ?? paramName;

  const rangeOptions = [
    { val: "49", name: "日本人" },
    { val: "50", name: "外国人" },
    { val: "0", name: "ドラフト" },
    { val: "30", name: "育成ドラフト" },
  ];
  const sequenceOptions = [...Array(20)].map((_, i) => {
    const val = String(i < 10 ? i + 1 : i + 1 + 20);
    const name = i < 10 ? `ドラフト${i + 1}位` : `育成ドラフト${i - 10 + 1}位`;
    return { val, name };
  });

  const hasRangeOptions = rangeOptions.some((s) => s.val === val);
  const hasSequenceOptions = sequenceOptions.some((s) => s.val === val);

  return (
    <div className="grid grid-cols-2">
      <Select
        paramName={paramName}
        val={hasRangeOptions ? val : paramName}
        id={paramName + "range"}
        disabled={hasSequenceOptions}
        hasParam={searchParams.has(paramName)}
      >
        <option value={paramName} disabled>
          日/外/ド/育ド
        </option>
        {rangeOptions.map((m) => (
          <option key={m.name} value={m.val}>
            {m.name}
          </option>
        ))}
      </Select>
      <Select
        paramName={paramName}
        val={hasSequenceOptions ? val : paramName}
        id={paramName + "sequence"}
        disabled={hasRangeOptions}
        hasParam={searchParams.has(paramName)}
      >
        <option value={paramName} disabled>
          指名順位
        </option>
        {sequenceOptions.map((m) => (
          <option key={m.name} value={m.val}>
            {m.name}
          </option>
        ))}
      </Select>
    </div>
  );
}

export function EnrFilter({ paramName }: { paramName: string }) {
  return (
    <Suspense
      fallback={
        <div className="grid grid-cols-2">
          <select className="select select-sm w-full max-w-xs"></select>
          <select className="select select-sm w-full max-w-xs"></select>
        </div>
      }
    >
      <Filter paramName={paramName} />
    </Suspense>
  );
}
